import { createContext, useContext } from 'react'

export interface SpotlightContextType {
    opened: boolean
    open: () => void
    close: () => void
}

export const SpotlightContext = createContext<SpotlightContextType | undefined>(undefined)

export const useSpotlight = () => {
    const context = useContext(SpotlightContext)
    if (!context) {
        throw new Error('useSpotlight must be used within a SpotlightProvider')
    }
    return context
} 